
<template>
  <!--订单管理-->
  <div>
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      rowKey="orderId"
      :initReqHandle="false"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_type" slot-scope="{row}">
        <span>{{row.type===1 ? '兑换' : '抽奖'}}</span>
      </template>

      <template slot="opt_name" slot-scope="{row}">
        <div class="product-name">
          <img style="height: 44px;" :src="row.productImg" alt="">
          <span>{{row.productName}}</span>
        </div>
      </template>

      <template slot="opt_status" slot-scope="{row}">
        <div style="display: flex; align-items: center">
          <span class="circle-dot" :class="row.status !== 2 ? 'success-bg' : 'primary-bg'"></span>
          <span>{{row.statusDesc}}</span>
        </div>
      </template>
    </x-tabula>

    <!--发货的弹窗-->
    <a-modal
      title="发货"
      :visible="visible"
      @cancel="closeModal"
      :okButtonProps="{ props: { disabled: canRequest } }"
      @ok="$refs.addEdit.handleSubmit()"
      :confirmLoading="btnLoading.loading"
      v-bind="$store.state.modalConfig"
      :width="750"
    >
      <x-tabula
        rowKey="orderId"
        :initReqHandle="false"
        :dataSource="goodsInfoData"
        :columns="goodsInfoColumns"
        :rowSelection="false"
        :paginationParam="false"
      >
        <template slot="opt_name" slot-scope="{row}">
          <div class="product-name">
            <img style="height: 44px;" :src="row.productImg" alt="">
            <span>{{row.productName}}</span>
          </div>
        </template>

        <template slot="opt_status" slot-scope="{row}">
          <div style="display: flex; align-items: center">
            <span class="circle-dot" :class="row.status !== 2 ? 'success-bg' : 'primary-bg'"></span>
            <span>{{row.statusDesc}}</span>
          </div>
        </template>
      </x-tabula>

      <div style="display: flex;justify-content: space-between">
        <ul class="menu">
          <li class="menu-list">配送信息</li>
          <li class="menu-list"></li>
          <li class="menu-list">物流信息</li>
        </ul>

        <x-addEdit
        style="margin-top: 24px; width: 650px"
        ref="addEdit"
        :itemLayout="{ labelCol: { span: 4 }, wrapperCol: { span: 8 } }"
        modalType="modal"
        :isSubmitBtn="false"
        :reqLoading="btnLoading"
        :formList="formList"
        :formKey="formKey"
        :addParam="addParam"
      />
        <a-button
          v-if="goodsInfoData[0].productType===1 && goodsInfoData[0].status === 3"
          @click="changeLogistics"
          style="margin-top: 152px"
          type="danger"
          ghost
        >修改物流</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { empty } from 'ant-design-vue-admin-x';
const orderType = [
  { value: 1, label: '兑换' },
  { value: 2, label: '抽奖' }
];

const orderStatus = [
  { value: 0, label: '未领取' },
  // { value: 1, label: '已领取' }, // app才有
  { value: 2, label: '待发货' },
  { value: 3, label: '交易完成' }
];
export default {
  name: 'order-1',
  data () {
    return {
      canRequest: true,
      logisticsParams: { companyId: undefined, logisticsNo: undefined },
      goodsInfoData: [{}],
      goodsInfoColumns: [
        { title: '商品编号', dataIndex: 'productId', align: '', width: '' },
        { title: '商品名称', dataIndex: 'productName', align: '', width: '', scopedSlots: { customRender: 'name' } },
        { title: '数量', dataIndex: 'productNumber', align: '', width: '' },
        { title: '状态', dataIndex: 'status', align: '', width: '', scopedSlots: { customRender: 'status' } }
      ],
      orderId: {},
      visible: false,
      btnLoading: { loading: false },
      formList: [
        {
          label: '收货人',
          inputType: 'text',
          options: [],
          handle: '',
          placeholder: '',
          props: ['receivingInfo', { rules: [] }]
        },
        {
          label: '收货地址',
          inputType: 'text',
          options: [],
          handle: '',
          placeholder: '',
          props: ['receivingAddress', { rules: [] }]
        },
        {
          label: '物流公司',
          inputType: 'select',
          options: [],
          handle: (e) => {
            this.logisticsParams.companyId = e;
          },
          placeholder: '请选择物流公司',
          props: ['logisticsCompanyId', {
            rules: [{ required: true, message: '请选择物流公司' }]
          }]
        },
        {
          label: '物流单号',
          inputType: 'input',
          options: [],
          handle: (e) => {
            this.logisticsParams.logisticsNo = e.target.value;
          },
          placeholder: '请输入物流单号',
          props: ['logisticsNo', {
            rules: [{ required: true, message: '请输入物流单号' }]
          }]
        }
      ],
      formKey: {
        receivingInfo: undefined,
        receivingAddress: undefined,
        logisticsCompanyId: undefined,
        logisticsNo: undefined
      },
      addParam: {
        url: '',
        reqHandle: this.reqHandle, // addParam、editParaM都会执行 reqHandle方法
        resHandle: '' // this.addResHandle
      },

      // table 参数
      searchList: [
        { props: ['phone'], placeholder: '账号', options: [], inputType: 'input' },
        { props: ['status'], placeholder: '状态', options: orderStatus, inputType: 'select' },
        { props: ['createTime'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' }, // startTime endTime
        { props: ['orderId'], placeholder: '订单ID', options: [], inputType: 'input' },
        { props: ['type'], placeholder: '订单类型', options: orderType, inputType: 'select' }
      ],
      tableOptList: [],
      rowOptList: [
        {
          text: '',
          handle: row => this.logisticsHandle(row), // 处理方法
          rowOptText: row => row.status === 2 ? '发货' : '查看', // 订单状态: 0未领取 1已领取 2待发货 3交易完成
          customRender: true,
          permi: ['community:order:logistics']
        }
      ],
      columns: [
        { title: '订单创建时间', dataIndex: 'createTime', align: '', width: '180px' },
        { title: '订单ID', dataIndex: 'orderId', align: '', width: '' },
        { title: '类型', dataIndex: 'type', align: '', width: '80px', scopedSlots: { customRender: 'type' } },
        { title: '账号', dataIndex: 'phone', align: '', width: '' },
        { title: '商品名称', dataIndex: 'productName', align: '', width: '270px', scopedSlots: { customRender: 'name' } },
        { title: '兑换价(积分)', dataIndex: 'points', align: '', width: '110px' },
        { title: '收货信息', dataIndex: 'receivingInfo', align: '', width: '', ellipsis: true },
        { title: '订单状态', dataIndex: 'status', align: '', width: '', scopedSlots: { customRender: 'status' } },
        { title: '操作', dataIndex: 'action', align: '', width: '90px', scopedSlots: { customRender: 'action' } }
      ],
      dataSource: [],
      searchParams: {
        phone: undefined,
        status: undefined,
        createTime: undefined,
        orderId: undefined,
        type: undefined
      },
      listApi: {
        url: '/pm/order/orderManageList',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: '',
        addTitle: '',
        editTitle: ''
      },
      deleteParam: {
        url: '',
        title: '',
        key: '',
        resHandle: '' // 执行完删除的回调方法
      }
    };
  },
  watch: {
    logisticsParams: {
      deep: true,
      handler (val) {
        console.log('watch companyId, logisticsNo: ', val.companyId, val.logisticsNo);
        if (this.goodsInfoData[0].productType !== 1 || this.goodsInfoData[0].status === 0) {
          this.canRequest = true;
        } else {
          val.companyId && val.logisticsNo ? this.canRequest = false : this.canRequest = true;
        }
      }
    }
  },
  mounted () {
    const orderId = this.$route.query.id;
    if (orderId) {
      this.$refs.table.$refs.search.changeFold();
      this.$nextTick(() => {
        this.$refs.table.$refs.search.form.setFieldsValue({ orderId: orderId });
        this.$refs.table.$refs.search.handleSearch();
      });
    } else {
      this.$refs.table.getTableList();
    }
  },
  methods: {
    /** 关闭弹窗（发货） */
    closeModal () {
      this.logisticsParams = { companyId: undefined, logisticsNo: undefined };
      this.visible = false;
    },
    /** 修改物流 */
    async changeLogistics (e) {
      await this.getLogisticsSelect();
      this.formList.forEach((item, index) => {
        if (index === 2) {
          item.inputType = 'select';
        }
        if (index === 3) {
          item.inputType = 'input';
        }
      });
      this.$nextTick(() => {
        let { receivingInfo, receivingAddress, logisticsCompanyId, logisticsNo } = this.goodsInfoData[0];
        empty.$emit('setForm', { logisticsCompanyId, logisticsNo, receivingInfo, receivingAddress });
        if (logisticsCompanyId && logisticsNo) {
          this.logisticsParams = { companyId: logisticsCompanyId, logisticsNo };
        }
      });
    },
    /** 打开发货、查看弹窗 */
    async logisticsHandle (row) {
      this.goodsInfoData = [row];
      const { receivingInfo, receivingAddress } = row;
      let obj = { receivingInfo, receivingAddress };
      this.canRequest = true;
      this.visible = true;
      await this.getLogisticsSelect();

      if (row.status !== 2) { // 状态: 0未领取 2待发货 3交易完成
        const { logisticsCompanyName, logisticsNo } = row;
        Object.assign(obj, { logisticsCompanyId: logisticsCompanyName, logisticsNo });
        this.formList.forEach((el) => { el.inputType = 'text'; });
      } else {
        this.formList.forEach((el, index) => {
          index === 2 && (el.inputType = 'select');
          index === 3 && (el.inputType = 'input');
        });
      }

      this.$nextTick(() => {
        this.orderId = row.orderId;
        empty.$emit('setForm', obj);
      });
    },
    getLogisticsSelect () {
      return new Promise((resolve, reject) => {
        this.$get({
          url: '/pm/logisticsCompany/treeSelect',
          params: {}
        }).then(({ data }) => {
          this.formList[2].options = data;
          resolve();
        });
      });
    },
    /** 提交前处理事件 */
    reqHandle (params) {
      if (this.goodsInfoData[0].status === 0) {
        return;
      }

      const { logisticsCompanyId, logisticsNo } = params;
      this.$put({
        url: '/pm/order/ship',
        params: {
          orderId: this.orderId,
          logisticsCompanyId,
          logisticsNo
        }
      }).then(({ data }) => {
        this.closeModal();
        this.$refs.table.getTableList();
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>

<style scoped lang="scss">
.product-name {
  display: flex;
  align-items: center;
  img {
    height: 44px;
  }
  span {
    margin-left: 10px;
  }
}
.menu {
  width: 100px;
  .menu-list {
    margin-top: 20px;
    height: 40px;
    line-height: 40px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    margin-bottom: 24px;
  }
}
</style>
